import { useCallback } from 'react';
import styles from './RewardPromoScreen.scss';
import { appActions } from '~/Store/appSlice';
import { useDispatch } from 'react-redux';
import useKeyDown, { KEYS_CODE } from '~/hooks/useKeyDown';
import { playButtonClickSound } from '@wg/web2clientapi/sound';
import ButtonEsc from '~/components/ButtonEsc/ButtonEsc';
import { t } from '~/utils/localization';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import Button from '~/components/Button/Button';
import Info from '~/components/Info/Info';
import { items } from '@wg/wows-entities/const';
import FullScreenBackgroundWithMask from '~/components/FullScreenBackgroundWithMask/FullScreenBackgroundWithMask';

interface IRewardPromoScreen {
    data: {
        backgroundImage: string;
        backgroundColor: string;
        backgroundVideo: IVideo;
        showDisclaimer?: boolean;
        additionalDescription?: string;
        item: IItemCommonData;
        onClose?: () => void;
    };
}

const RewardPromoScreen = ({ data }: IRewardPromoScreen) => {
    const dispatch = useDispatch();
    const close = useCallback(() => {
        data.onClose?.();
        dispatch(appActions.changeVisibilityPopup({ name: null }));
    }, [data]);

    useKeyDown(() => {
        playButtonClickSound();
        close();
    }, [KEYS_CODE.ESC]);

    let text = t('You received a new item');
    if (data.item.type === items.VEHICLES) {
        text = t('You received a new ship');
    } else if (data.item.type === items.CREWS) {
        text = t('You received a new commander');
    }

    return (
        <div className={styles.popup} key={`reward_promo_${data.item.type}_${data.item.identifier}`}>
            <FullScreenBackgroundWithMask backgroundImage={data.backgroundImage} backgroundColor={data.backgroundColor} backgroundVideo={data.backgroundVideo} />
            <div className={styles.close}>
                <ButtonEsc onClick={close} />
            </div>
            <div className={styles.contentWrapper}>
                <div className={styles.header}>{t('Congratulations!')}</div>
                <div className={styles.footer}>
                    <div className={styles.footerTitle}>{text}</div>
                    <div className={styles.weWidget}>
                        <WoWSEntity
                            type={data.item.type}
                            id={data.item.identifier}
                            presentation={{
                                withTooltip: true,
                            }}
                        />
                    </div>
                    <div className={styles.buttons}>
                        <Button label={t('Закрыть')} onClick={close} />
                    </div>
                    {data.showDisclaimer && (
                        <div className={styles.disclaimer}>
                            <Info className={styles.infoIcon} />
                            <span>{t('Visuals and descriptions shown in the Armory may differ from other appearances in the game.')}</span>
                        </div>
                    )}
                    {data.additionalDescription && <div className={styles.additinalDescription} dangerouslySetInnerHTML={{ __html: data.additionalDescription }} />}
                </div>
            </div>
        </div>
    );
};

export default RewardPromoScreen;
